import { UPDATE_PROGRAM_DATA, UPDATE_PROGRAM_DATA_EMPTY, UPDATE_PROGRAM_DATA_ERROR, UPDATE_PROGRAM_DATA_SUCCESS } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateProgramData = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROGRAM_DATA:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_PROGRAM_DATA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_PROGRAM_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_PROGRAM_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateProgramData;
